import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryParamProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '..';
import { REWARD_CENTER_ONBOARDING_STEPS } from '../../components/OnboardingLayer/onboardingSteps';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { setOnboardingStep as _setOnboardingStep } from '../../state/actions/currentOnboarding';
import { markOnboardingSeen as _markOnboardingSeen } from '../../state/actions/ftue';

var RewardCenterOnboarding = /*#__PURE__*/function (_Component) {
  _inherits(RewardCenterOnboarding, _Component);

  var _super = _createSuper(RewardCenterOnboarding);

  function RewardCenterOnboarding() {
    var _this;

    _classCallCheck(this, RewardCenterOnboarding);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this._clickHandler = function () {
      var _this$props = _this.props,
          markOnboardingSeen = _this$props.markOnboardingSeen,
          setOnboardingStep = _this$props.setOnboardingStep;
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, undefined));
      setOnboardingStep(REWARD_CENTER_ONBOARDING_STEPS.SECOND_VISIT);
      markOnboardingSeen(ONBOARDING_FLOWS.REWARD_CENTER);
      QueryParamProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.RewardCenter));
    };

    return _this;
  }

  _createClass(RewardCenterOnboarding, [{
    key: "render",
    value: function render() {
      return this.props.render({
        clickHandler: this._clickHandler
      });
    }
  }]);

  return RewardCenterOnboarding;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAccountLinked: state.playerInfo.isAccountLinked
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setOnboardingStep: function setOnboardingStep(step) {
      dispatch(_setOnboardingStep(step));
    },
    markOnboardingSeen: function markOnboardingSeen(onboardingFlow) {
      dispatch(_markOnboardingSeen(onboardingFlow));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RewardCenterOnboarding);